const accuproSavingsCalculator = (data) => ({
    ...window.helpers,
    data: JSON.parse(decodeURIComponent(data)),
    step: 0,
    step_mobile: 0,
    getDeliveriesByPosition() {
        if (this.step > 5) {
            return 1
        }
        return parseInt(this.step, 10) + 1
    },
    getDeliveriesByPositionMobile() {
        const values = {
            0: 1,
            1: 3,
            2: 6,
        }
        return parseInt(values[this.step_mobile], 10)
    },
    get economySavings() {
        if (this.data.economy === null) {
            return 0
        }
        return ((this.getDeliveriesByPosition() * 12 * parseFloat(this.data.economy.delivery_option_price)) - this.data.accupro_cost) / 12
    },
    get economySavingsMobile() {
        if (this.data.economy === null) {
            return 0
        }
        return ((this.getDeliveriesByPositionMobile() * 12 * parseFloat(this.data.economy.delivery_option_price)) - this.data.accupro_cost) / 12
    },
    get expressSavings() {
        if (this.data.express === null) {
            return 0
        }
        return ((this.getDeliveriesByPosition() * 12 * parseFloat(this.data.express.delivery_option_price)) - this.data.accupro_cost) / 12
    },
    get expressSavingsMobile() {
        if (this.data.express === null) {
            return 0
        }
        return ((this.getDeliveriesByPositionMobile() * 12 * parseFloat(this.data.express.delivery_option_price)) - this.data.accupro_cost) / 12
    },
    get accuproCost() {
        return this.data.accupro_cost / 12
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('accuproSavingsCalculator', accuproSavingsCalculator)
})
